<template>
    <div class="grid">
        <div class="col-12">
            <div class="col-12 sticky">
                <div id="custom_card" class="card">
                    <div class="grid justify-content-between">
                        <div class="col-12 md:col-6">
                            <div
                            class="flex flex-wrap align-items-center justify-content-center md:justify-content-start md:mb-0 mb-3"
                            >
                            <p style="color: #3f51b5; font-size: 20px; font-weight: 800">
                                {{ $t("asset_disposalreport") }}
                            </p>
                            </div>
                        </div>
                        <div class="col-12 md:col-6">
                            <div class="flex flex-wrap align-items-center justify-content-end md:justify-content-end md:mb-0 mb-3">
                                <Button @click="print" class="p-button-rounded p-button-danger" icon="pi pi-file-pdf" v-tooltip.bottom="$t('pdf')"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                
                <div class="container Application_container mt-4">
                    <div class="p-fluid formgrid grid">
                        <div class="field col-12 md:col-2">
                            <span class="p-float-label">
                            <Dropdown
                                id="status"
                                v-model="status_dropdownItem"
                                :options="asset_status_master"
                                optionLabel="name"
                                filter
                                @change="GetReport()"
                            >
                            </Dropdown>
                            <label>{{ $t("search_year") }}</label>
                            </span>
                        </div>
                    </div>
                </div>
                <!-- Printable Section -->
                <div id="printMe">
                    <div class="container Application_container mt-4 text-center">
                        <b style="font-size: 2rem;">{{ $t("Labour_Commissionerate") }}</b>
                        <p class="mt-4">
                            {{ $t("asset_disposal_report_fy") }} : <b>{{ year }}</b>
                        </p>
                    </div>
                    <div class="container Application_container mt-4 text-left">
                        <p>{{ $t("report_date") }} : {{ getCurrentDate() }}</p>
                    </div>
                    <!-- Table Wrapper -->
                    <div class="print-wrapper">
                        <table class="table table-bordered" style="border: 1px solid black; width: 100%;">
                            <thead>
                                <tr>
                                    <th><strong>{{ $t("asset_code") }}</strong></th>
                                    <th><strong>{{ $t("asset_discription") }}</strong></th>
                                    <th><strong>{{ $t("original_cost") }}</strong></th>
                                    <th><strong>{{ $t("accumulated_depreciation") }}</strong></th>
                                    <th><strong>{{ $t("net_book_value_at_disposal") }}</strong></th>
                                    <th><strong>{{ $t("disposal_date") }}</strong></th>
                                    <th><strong>{{ $t("disposal_amount") }}</strong></th>
                                      <th><strong>{{ $t("profit_loss") }}</strong></th>
                                        <th><strong>{{ $t("disposal_method") }}</strong></th>
                                    <th><strong>{{ $t("writoff_reason") }}</strong></th>
                                </tr>
                            </thead>
                            <tbody v-for="item in rows" :key="item.id">
                                <tr>
                                    <td>{{ item.asset_code }}</td>
                                    <td>{{ item.asset_discription }}</td>
                                    <td>{{ item.original_cost }}</td>
                                    <td>{{ item.accumulated_depreciation }}</td>
                                     <td>{{ item.net_book_value_at_disposal }}</td>
                                      <td>{{ dateFormatDMY(item.disposal_date) }}</td>
                                     <td>{{ item.disposal_amt }}</td>
                                    <td v-if="item.profit_loss < 0" style="color:red">{{ item.profit_loss }}</td>
                                    <td v-else style="color:green">{{ item.profit_loss }}</td>
                                    <td>{{ item.disposal_method }}</td>
                                     <td>{{ item.asset_writoff_reason }}</td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td><strong>{{ $t("total") }}</strong></td>
                                    <td></td>
                                    <td><strong>{{ total_original_cost }}</strong></td>
                                    <td><strong>{{ total_accumulated_depreciation }}</strong></td>
                                    <td><strong>{{ total_net_book_value }}</strong></td>
                                    <td></td>
                                    <td><strong>{{ total_disposal_amt }}</strong></td>
                                    <td>
                                        <strong v-if="total_profit_loss < 0" style="color:red">{{ total_profit_loss }}</strong>
                                        <strong v-else style="color:green">{{ total_profit_loss }}</strong>
                                    </td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import apis from "@/apis";
import axios from "axios";
export default {
    name: "MahatakrarDepreciationHistoryAssetWise",
    data() {
        return {
            year:'',
            total_original_cost: "0.00",
            total_accumulated_depreciation: "0.00",
            total_net_book_value: "0.00",
            total_disposal_amt: "0.00",
            total_profit_loss: "0.00",
            rows: [],
            asset_status_master: [],
            status_dropdownItem: null,
        };
    },
    async mounted() {
        this.asset_status_master = this.getPreviousTenFinancialYears();
    },
    methods: {
        getPreviousTenFinancialYears() 
        {
            const financialYears = [];
            const currentMonth = new Date().getMonth(); // 0-indexed (0 for Jan, 11 for Dec)
            const currentYear = new Date().getFullYear();
            let startYearOfCurrentFY;
            // Determine the starting year of the current financial year
            // If current month is Jan, Feb, or Mar, the FY started in April of the previous calendar year.
            // Otherwise (Apr-Dec), the FY started in April of the current calendar year.
            if (currentMonth >= 0 && currentMonth <= 2) { // January, February, March
                startYearOfCurrentFY = currentYear - 1;
            } else { // April to December
                startYearOfCurrentFY = currentYear;
            }
            for (let i = 0; i < 10; i++) {
                const startYear = startYearOfCurrentFY - i;
                const endYear = startYear + 1;
                financialYears.push({
                name: `${startYear}-${endYear}`,
                value: `${startYear}`
                });
            }
            return financialYears;
        },
        getCurrentDate() {
            const today = new Date();
            const day = String(today.getDate()).padStart(2, "0");
            const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are 0-based
            const year = today.getFullYear();
            return `${day}-${month}-${year}`;
        },
        dateFormatDMY(inputDate) {
            var postdate = inputDate;
            if (inputDate) {
                inputDate = new Date(inputDate);
                if (inputDate.toString() == "NaN-NaN-NaN") {
                    return postdate;
                } else {
                    let date = ("0" + inputDate.getDate()).slice(-2);
                    // current month
                    let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
                    // current year
                    let year = inputDate.getFullYear();
                    if (date.toString() == "aN") {
                        return postdate;
                    } else {
                        return date + "/" + month + "/" + year;
                    }
                }
            } else {
                return "";
            }
        },
        back() {
            this.$router.push({
                name: "asset",
            });
        },
        async print() {
            // Pass the element id here
            await this.$htmlToPaper('printMe');
        },
        GetReport() {
            this.rows =[];
                    this.total_original_cost='0.00';
                    this.total_accumulated_depreciation='0.00';
                    this.total_net_book_value='0.00';
                    this.total_disposal_amt='0.00';
                    this.total_profit_loss='0.00';
                        this.year='';
            var data = {
                client_id: localStorage.getItem("client_id"),
               year: this.status_dropdownItem?.value
            };
            var promise = apis.get_asset_disposal_report(data);
            promise.then((response) => {
                if (response.data.status == true && response.data.data.length > 0) {
                    this.year = this.status_dropdownItem?.name;
                    this.rows = response.data.data;
                    this.total_original_cost = response.data.total.total_original_cost;
                    this.total_accumulated_depreciation =
                        response.data.total.total_accumulated_depreciation;
                        this.total_net_book_value =
                        response.data.total.total_net_book_value_at_disposal;
                        this.total_disposal_amt = response.data.total.total_disposal_amt;
                        this.total_profit_loss = response.data.total.total_profit_loss;
                } else {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error!!!",
                        detail: "Details Not Found",
                        life: 3000,
                    });
                    return false;
                }
            });
        },
    },
};
</script>
<style scoped>
.bold {
    font-weight: bold;
    font-size: 14px;
    color: #000;
}
table,
th,
td {
    border: 1px solid black;
    border-collapse: collapse;
}
.table td {
    padding: 5px 10px;
}
.head {
    text-align: left;
}
/* Wrapper for scroll in screen view */
.print-wrapper {
    overflow: auto;
    max-height: 400px;
}
/* PRINT-SPECIFIC STYLES */
@media print {
    /* Remove scrollbar and allow full content */
    .print-wrapper {
        overflow: visible !important;
        max-height: none !important;
    }
    /* Make table fit page width */
    table {
        width: 100% !important;
        table-layout: auto !important;
        word-wrap: break-word;
    }
    th,
    td {
        white-space: normal !important;
        word-break: break-word;
    }
    .p-button-danger,
    .p-button-rounded {
        display: none !important;
    }
    @page {
        size: landscape;
        /* Optional: wider page for table */
        margin: 10mm;
    }
}
</style>
